import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "border-t-2 border-b-2 py-2 px-6 mb-2 border-blue-50 flex justify-center items-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 py-3 text-sm md:text-md" }, "An update is available", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.updateExists)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "btn btn-primary btn-small block-inline",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refreshApp && _ctx.refreshApp(...args)))
        }, " Update ")
      ]))
    : _createCommentVNode("", true)
}